module.exports = __webpack_public_path__ + "img/silver-3.40fdf3dc.png";